module.exports = __webpack_public_path__ + "static/focus-6c8b04a3ebd3945575ba8b03a1958e8d.png";